<template>
  <el-dialog
    v-model="show"
    width="500px"
    :title="title"
    top="5vh"
    @closed="close"
    :append-to-body="appendToBody"
    class="user-grid-dialog"
  >
    <user-grid :users="users"></user-grid>
  </el-dialog>
</template>

<script>
import UserGrid from "./UserGrid";

export default {
  emits: ["closed"],
  props: {
    users: Array,
    title: String,
    appendToBody: Boolean
  },
  components: {
    "user-grid": UserGrid
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    close() {
      this.$emit("closed");
    }
  }
};
</script>

<style>
  .user-grid-dialog{
    background: var(--backgroundColor);
  }
  .user-grid-dialog .el-dialog__title{
    color: var(--textGeneralColor);
  }
</style>
